import React from 'react';
import './all-styles.scss';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { string, func } from 'prop-types';
import { Metadata } from '@thd-olt-component-react/metadata';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Error } from './pages';
import { getRoutes } from './routes';
import P2pBreadcrumbs from './components/common/P2pBreadcrumbs/P2pBreadcrumbs';
import { NotificationsProvider } from './components/NotificationsProvider/NotificationsProvider';
import StoreProvider from './store';
import { EXP_ROUTES } from './utils/constants';
import ProfileDetails from './pages/ProfileDetails/ProfileDetails';
import { JobPostingPage } from './pages/JobPostings/JobPostingPage/JobPostingPage';
import { CreateJobPostingPage } from './pages/JobPostings/CreateJobPostingPage/CreateJobPostingPage';
import { JobTemplatePage } from './pages/JobPostings/JobTemplatePage/JobTemplatePage';
import { CompanyProfilePage } from './pages/JobPostings/CompanyProfile/CompanyProfilePage';

export const App = ({ currentRouteName, currentRouteComponent }) => {
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <div className="slm__container">
      <ErrorBoundary name="metadata">
        <Metadata
          title="Hire Skilled Labor. Free with Pro Xtra – The Home Depot"
          description="Connect with skilled labor your business needs by trade & location. View labor portfolio, experience, qualifications, references all in one place!"
          data={{
            canonicalURL: '/path-to-pro-network',
            siteName: 'The Home Depot',
            title: 'Hire Skilled Labor. Free with Pro Xtra – The Home Depot',
            description: 'Connect with skilled labor your business needs by trade & location. View labor portfolio, experience, qualifications, references all in one place!',
            type: 'Content',
            image: 'https://assets.thdstatic.com/images/v1/path-to-pro/landing-page-banner-2.jpg',
            facebookAdmins: '100005416960152'
          }}
        />
      </ErrorBoundary>
      <StoreProvider>
        <NotificationsProvider>
          <ErrorBoundary name="scroll-to-top">
            <ScrollToTop />
          </ErrorBoundary>
          <ErrorBoundary name="breadcrumbs">
            <P2pBreadcrumbs />
          </ErrorBoundary>
          <Routes>
            <Route path={EXP_ROUTES.SEARCH_PROFILE(':candidateId')} element={<ProfileDetails />} />
            <Route path={EXP_ROUTES.DASHBOARD_PROFILE(':candidateId')} element={<ProfileDetails />} />
            <Route path={EXP_ROUTES.APPLICANTS_PROFILE(':jobPostingId', ':candidateId')} element={<ProfileDetails />} />
            <Route path={EXP_ROUTES.CREATE_JOB_POSTING} element={<CreateJobPostingPage />} />
            <Route path={EXP_ROUTES.JOB_POSTING(':jobPostingId')} element={<JobPostingPage />} />
            <Route path={EXP_ROUTES.EDIT_JOB_POSTING(':jobPostingId', false)} element={<JobPostingPage />} />
            <Route path={EXP_ROUTES.JOB_RECOMMENDED(':jobPostingId')} element={<JobPostingPage />} />
            <Route path={EXP_ROUTES.JOB_APPLICANTS(':jobPostingId')} element={<JobPostingPage />} />
            <Route path={EXP_ROUTES.JOB_TEMPLATE(':jobTemplateId')} element={<JobTemplatePage />} />
            <Route path={EXP_ROUTES.JOB_TEMPLATES} element={<JobTemplatePage />} />
            <Route path={EXP_ROUTES.COMPANY_PROFILE} element={<CompanyProfilePage />} />
            <Route exact path={routes.landing.path} element={<routes.landing.component />} />
            <Route exact path={routes.network.path} element={<routes.network.component />} />
            <Route path={routes.main.path} element={<routes.main.component />} />
            <Route path="/error" element={<Error />} />
            <Route element={<Error />} />
          </Routes>
        </NotificationsProvider>
      </StoreProvider>
    </div>
  );
};

App.propTypes = {
  currentRouteName: string,
  currentRouteComponent: func
};

App.defaultProps = {
  currentRouteName: null,
  currentRouteComponent: null
};
